import { render } from "./BaseStatisticsItem.vue?vue&type=template&id=68036df6"
import script from "./BaseStatisticsItem.vue?vue&type=script&lang=js"
export * from "./BaseStatisticsItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__